import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/dashboard/ui";

export default function ProtectedRoute({ children, roles, perm }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen"><Loader /></div>;
  if (!user) return <Navigate to="/connexion" replace />;
  if (perm && !(user.effective_permissions || []).includes(perm)) return <Navigate to="/espace" replace />;
  if (roles && !roles.some((r) => (user.roles || []).includes(r)) && !(user.effective_permissions || []).length)
    return <Navigate to="/espace" replace />;
  return children;
}
